import React from 'react';
import PropTypes from 'prop-types';
import { generateOpeningHours } from '../../services/opening-hours';
import i18next from 'i18next';

import './OpeningHours.scss';

const OpeningHours = ({ availabilityHours }) => {
    const formattedHours = generateOpeningHours(availabilityHours);

    return formattedHours ? (<div className="pi opening-hours">
        <label className="label">{i18next.t('openingHours.label')}:</label>
        {Object.keys(formattedHours).map(day => {
            return (
                <div key={day} className="day-container">
                    <span className="day">{i18next.t(`openingHours.weekDays.${day}`)}:
                    </span> {formattedHours[day].map((range, i) => <span key={i}>{`${range}${i < formattedHours[day].length - 1 ? ', ' : ''}`}</span>)}
                </div>
            );
        })}
    </div>) : null;
};

OpeningHours.propTypes = {
    availabilityHours: PropTypes.array
};

export default OpeningHours;
